import styled from "@emotion/styled";
import { Box, ImageListItem, Tab, Tabs, Typography } from "@mui/material";
import { FC, useState } from "react";
import realizationsData from "./realizationsData";
import Lightbox from "yet-another-react-lightbox";
import Zoom from "yet-another-react-lightbox/plugins/zoom";


const SectionTitle = styled(Typography)`
    padding: 8px;
    font-family: Quicksand, Nunito, Rubik, Poppins, Inter, Roboto, "Segoe UI", Arial, sans-serif;
    font-weight: 500;
    font-size: 1.8rem;
    color: #222;
    max-width: 100%;
`;


interface RealizationsProps {

}

const Realizations: FC<RealizationsProps> = () => {
    const [value, setValue] = useState(0);
    const [filteredItems, setFilteredItems] = useState(realizationsData);
    const [index, setIndex] = useState(0);
    const [showLightbox, setShowLightbox] = useState(false);

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };


    const filterItems = (premise: string) => {
        if (premise) {
            if (premise === 'Wszystkie') return setFilteredItems(realizationsData);
            setFilteredItems(realizationsData.filter(item => item.premise === premise));
        } else {
            setFilteredItems(realizationsData);
        }
    }


    return (
        <>
            <SectionTitle sx={{ mt: 4, ml: 1 }}>Nasze realizacje</SectionTitle>
            <Box
                sx={{
                    width: '100%',
                    maxWidth: '900px',
                    bgcolor: 'background.paper',
                    overflowX: 'auto',
                    mt: 1,
                    mx: 'auto',
                    position: 'relative',
                    '@media (max-width:900px)': {
                        width: '100vw',
                        maxWidth: '100vw',
                        left: '50%',
                        right: '50%',
                        marginLeft: '-50vw',
                        marginRight: '-50vw',
                    },
                    '& .MuiTabs-root': {
                        minHeight: 0,
                    },
                    '& .MuiTab-root': {
                        color: '#222',
                        fontFamily: 'Quicksand, Nunito, Rubik, Poppins, Inter, Roboto, "Segoe UI", Arial, sans-serif',
                        fontWeight: 400,
                        fontSize: '1.08rem',
                        minHeight: 0,
                        minWidth: 90,
                        padding: '12px 22px 10px 22px',
                        letterSpacing: '0.01em',
                        transition: 'color 0.18s, border-bottom 0.18s, background 0.18s',
                        borderBottom: '2.5px solid transparent',
                        '&:hover': {
                            color: '#bfa14b',
                            background: 'rgba(191,161,75,0.07)',
                        },
                    },
                    '& .Mui-selected': {
                        color: '#bfa14b !important',
                        fontWeight: 600,
                        borderBottom: '2.5px solid #bfa14b',
                        background: 'rgba(191,161,75,0.07)',
                    },
                    '& .MuiTabs-indicator': {
                        display: 'none',
                    },
                }}
            >
                <Tabs
                    value={value}
                    onChange={handleChange}
                    variant="scrollable"
                    scrollButtons="auto"
                    allowScrollButtonsMobile
                    sx={{
                        width: '100%',
                        '.MuiTabs-flexContainer': {
                            width: '100%',
                        }
                    }}
                >
                    <Tab label="Wszystkie" onClick={() => filterItems('Wszystkie')} />
                    <Tab label="Kuchnie" onClick={() => filterItems('Kuchnie')} />
                    <Tab label="Salony" onClick={() => filterItems('Salony')} />
                    <Tab label="Sypialnie" onClick={() => filterItems('Sypialnie')} />
                    <Tab label="Biura" onClick={() => filterItems('Biura')} />
                    <Tab label="Łazienki" onClick={() => filterItems('Łazienki')} />
                    <Tab label="Przedpokoje" onClick={() => filterItems('Przedpokoje')} />
                    <Tab label="Inne" onClick={() => filterItems('Inne')} />
                </Tabs>
            </Box>
            <Box sx={{ flexWrap: 'wrap', justifyContent: 'space-around', width: '100%', display: 'flex', mt: 2 }}>
                {filteredItems.map((item, index) => (
                    <ImageListItem
                        key={index}
                        onClick={() => {
                            setIndex(index);
                            setShowLightbox(true);
                        }}
                        sx={{
                            cursor: 'pointer',
                            width: '100%',
                            maxWidth: '280px',
                            m: '5px',
                            mt: '10px',
                            '@media (max-width: 400px)': {
                                maxWidth: '100%',
                                m: '7px 15px'
                            },
                        }}
                    >
                        <img
                            src={item.img}
                            alt={item.title}
                        />
                    </ImageListItem>
                ))
                }
            </Box>
            <Lightbox
                plugins={[Zoom]}
                open={showLightbox}
                close={() => setShowLightbox(false)}
                slides={filteredItems.map(item => ({ src: item.img }))}
                index={index}
                animation={{ fade: 0 }}
                controller={{ closeOnPullDown: true, closeOnBackdropClick: true }}
            />
        </>
    )
}

export default Realizations;